module.exports = __webpack_public_path__ + "img/monitor-mobbile.34ab7030.png";